const NotificationEmailTemplateRepository = function (baseRepository, baseCachedRepository) {

    angular.extend(this, baseRepository);
    angular.extend(this, baseCachedRepository);

    this.getCacheName = function () {
        return 'notificationEmailTemplateRepository';
    };

    this.getCacheCapacity = function () {
        return 100;
    };

    this.loadActions = function (id) {
        var url = '/rest/Actions',
            cacheKey = 'notificationEmailTemplate-actions-' + id,
            config = {
                params: {
                    uri: 'com.firstbest.underwriting.notification.NotificationEmailTemplate:' + id
                }
            };

        return this.get(cacheKey, url, config);
    };

    this.getNotificationEmailTemplate = function (id) {
        var url = '/rest/NotificationEmailTemplate/' + id,
            cacheKey = 'notificationEmailTemplate-' + id;
        return this.get(cacheKey, url);
    };

    this.saveNotificationEmailTemplate = function (notificationEmailTemplate) {
        var url = '/rest/NotificationEmailTemplate',
            body = notificationEmailTemplate,
            config = {
                params: {}
            },
            cacheKey = 'notificationEmailTemplate-' + notificationEmailTemplate.id;
        if (notificationEmailTemplate.id) {
            url = '/rest/NotificationEmailTemplate/' + notificationEmailTemplate.id;
            this.removeFromCache(cacheKey);
        }
        return this.post(url, body, config);
    };

    this.deleteNotificationEmailTemplate = function (id) {
        var url = '/rest/NotificationEmailTemplate/' + id;
        return this.delete(url);
    };

    this.processResponseData = function (responseData) {
        return responseData;
    };
};

angular.module('umCore')
    .service('notificationEmailTemplateRepository', NotificationEmailTemplateRepository);
